import { useQuery } from "@apollo/client/react"; import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';

export const StepProgramaDI = ({
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [datosProgramaDI, setDatosProgramaDI] = useState(fullFormDataRI?.programaDI1 ?? {});
  const [combosRI, setCombosRI] = useState();

  const inputCombos = inputs.filter((input) => !!input.comboName);

  const handleSubmit = () => {
    updateFormData('programaDI1', datosProgramaDI, parsedInputs);
  };
  const onDeleteImage = (inputName) => handleChange(inputName, null);

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const handleChange = (name, value) => {
    setDatosProgramaDI((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const handleChangeFile = (name, value) => {
    obtenerDataImagen(value).then((image) => {
      handleChange(name,
        {
          contentType: image?.tipo,
          archivo: image?.data,
          extension: image?.extension,
          titulo: image?.nombre
        }
      );
    });
  };

  const parsedInputs = useMemo(() => {

    if (!combosRI) return inputs;

    return inputs.map((input) => {
      if (!!input.comboName) {
        input.options = combosRI[input.name];
      }

      if (input.name === 'videodeglucionAdjunto') {
        input.required = !!datosProgramaDI.videodeglucion;
        input.disabled = !datosProgramaDI.videodeglucion;
        input.onDeleteImage = () => handleChange('videodeglucionAdjunto', null);
        if (input.disabled) input.onDeleteImage();
      }
      return input;
    });
  }, [combosRI, datosProgramaDI.videodeglucion]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [datosProgramaDI, setDataSubmissionCallback, parsedInputs]);

  return (
    <div className='step-form-section-container'>
      <Grid container>
        {parsedInputs.map((input) => {
          return (
            <RenderInputByTypeMobile
              key={`${input.displayName}-${input.name}`}
              grided
              marginedBottom
              handleDelete={() => onDeleteImage(input.name)}
              handleChange={input.type === 'file' ? handleChangeFile : handleChange}
              input={input}
              value={datosProgramaDI[input.name]} />);


        })}
      </Grid>
    </div>);

};

const inputs = [
  {
    displayName: 'Videodeglución',
    name: 'videodeglucion',
    type: 'boolean',
    required: true
  },
  {
    displayName: 'Subir Informe de Videodeglución',
    name: 'videodeglucionAdjunto',
    maxFileSize: 8,
    validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
    required: true,
    disabled: false,
    type: 'file'
  },
  {
    displayName: 'Disfagia a',
    name: 'dIDisfagiaARI',
    comboName: 'Disfagia',
    required: true,
    type: 'multiple_select'
  },
  {
    displayName: 'Episodios anteriores de neumonía',
    name: 'episodiosNeumonia',
    required: true,
    type: 'boolean'
  },
  {
    displayName: 'Alimentación actual',
    name: 'dIAlimentacionActualRI',
    comboName: 'Alimentación actual',
    required: true,
    type: 'multiple_select'
  },
  {
    displayName: 'Hidratación actual',
    name: 'dIHidratacionActualRI',
    comboName: 'Hidratacion actual',
    required: true,
    type: 'multiple_select'
  },
  {
    displayName: 'Traqueostomía',
    name: 'traqueostomia',
    required: true,
    type: 'boolean'
  },
  {
    displayName: 'Lúcido',
    name: 'lucido',
    required: true,
    type: 'boolean'
  },
  {
    displayName: 'Compromiso motor',
    name: 'compromisoMotor',
    required: true,
    type: 'boolean'
  }
  // {
  //     name: 'idComboRIValorKarnofsky',
  //     displayName: 'Karnofsky',
  //     comboName: 'Karnofsky',
  //     required: true,
  //     type: 'select'
  // }
];